<template>
	<div>
		<div style="display: flex;width: 350px;align-items: center;justify-content: space-between;">
			<div>
				考生昵称: <span>{{this.$route.query.userName}}</span>
			</div>
			<div>
				考试id: <span>{{this.$route.query.userId}}</span>
			</div>
		</div>
		<div style="display: flex;width: 380px;align-items: center;margin: 30px 0;">
			<div>
				是否合格: <span>{{this.$route.query.isQualified ? '合格' : '不合格'}}</span>
			</div>
			<div style="margin-left:41%;">
				得分: <span>{{this.$route.query.score}}分</span>
			</div>
		</div>
		<div style="display: flex;width: 350px;align-items: center;justify-content: space-between;">
			<div>
				提交时间: <span>{{this.$route.query.createdAt}}</span>
			</div>
		</div>
		<div style="display: flex;width: 350px;align-items: center;justify-content: space-between;margin-top: 30px;">
			<div>
				试卷名称:{{this.$route.query.title}}
			</div>
		</div>

		<el-table :data="tableDate" style="margin-top: 30px;"
			:header-cell-style="{ background: '#d7d7d7', color: '#333' }">
			<el-table-column label="题目">
				<template slot-scope="scope">
					{{scope.row.questionsEntity.questionContext}}
				</template>
			</el-table-column>
			<el-table-column label="考生回答">
				<template slot-scope="scope">
					{{scope.row.infoValue.titie}}:{{scope.row.infoValue.value}}
				</template>
			</el-table-column>
			<el-table-column label="标准答案">
				<template slot-scope="scope">
					{{scope.row.questionsEntity.correctAnswer}}
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableDate: []
			}
		},
		methods: {
			getInfo() {
				this.$http.post('/api/course/clrAnswerInformation/select', {
					examineeId: this.$route.query.examineeId,
					testPaperId: this.$route.query.testPaperId,
					// examQuestionsId: this.$route.query.examQuestionsId,
					// isTrue: this.$route.query.isTrue
				}).then(res => {
					console.log(res);
					console.log(res.data.data);
					this.tableDate = res.data.data
				})
			}
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">

</style>
